import { computed } from 'mobx';
import ApiModel     from './globals/ApiModel';

export default class StandMessageModel extends ApiModel {
  static get path() {
    return '/backend/stand_messages/{?id}';
  }

  @computed
  get newStandStatus(): string {
    return this.get('newStandStatus');
  }

  @computed
  get messageId(): id {
    return this.get('message.id');
  }
}
